import React from 'react'
import PropTypes from 'prop-types'
import {
  IconFAWrapper,
  ICON_FA_VARIANT_SOLID,
  ICON_FA_VARIANT_REGULAR,
  ICON_FA_VARIANT_LIGHT
} from './IconFAWrapper'

export const IconFACheck = ({
  className,
  variant,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      {variant === ICON_FA_VARIANT_SOLID ? (
        // <svg
        //   aria-hidden='true'
        //   focusable='false'
        //   data-prefix='fas'
        //   data-icon='check'
        //   role='img'
        //   viewBox='0 0 512 512'
        // >
        //   <path
        //     shapeRendering='geometricPrecision'
        //     fill='currentColor'
        //     d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'
        //   />
        // </svg>
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fas'
          data-icon='check'
          role='img'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 13 9'
        >
          <path
            d='M11.9191 1.46987C12.0545 1.60528 12.1222 1.76972 12.1222 1.96317C12.1222 2.15662 12.0545 2.32106 11.9191 2.45647L6.66685 7.70871L5.68025 8.69531C5.54483 8.83073 5.38039 8.89844 5.18694 8.89844C4.99349 8.89844 4.82906 8.83073 4.69364 8.69531L3.70703 7.70871L1.08092 5.08259C0.945499 4.94717 0.87779 4.78274 0.87779 4.58929C0.87779 4.39583 0.945499 4.2314 1.08092 4.09598L2.06752 3.10937C2.20294 2.97396 2.36737 2.90625 2.56083 2.90625C2.75428 2.90625 2.91871 2.97396 3.05413 3.10937L5.18694 5.24944L9.94587 0.483258C10.0813 0.347842 10.2457 0.280133 10.4392 0.280133C10.6326 0.280133 10.7971 0.347842 10.9325 0.483258L11.9191 1.46987Z'
            fill='currentColor'
          />
        </svg>
      ) : variant === ICON_FA_VARIANT_REGULAR ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='far'
          data-icon='check'
          role='img'
          viewBox='0 0 512 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z'
          />
        </svg>
      ) : (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fal'
          data-icon='check'
          role='img'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 448 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z'
          />
        </svg>
      )}
    </IconFAWrapper>
  )
}

IconFACheck.defaultProps = {
  variant: ICON_FA_VARIANT_SOLID
}

IconFACheck.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    ICON_FA_VARIANT_SOLID,
    ICON_FA_VARIANT_REGULAR,
    ICON_FA_VARIANT_LIGHT
  ]),
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
